module.exports = __webpack_public_path__ + "img/wx2code.089ba526.png";